import { render, staticRenderFns } from "./orders-checker.vue?vue&type=template&id=a2feb68c"
import script from "./orders-checker.vue?vue&type=script&lang=js"
export * from "./orders-checker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports